import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import './ContactScheduler.scss';

import ContactForm from './ContactForm/ContactForm';

import Api from '../../Shared/Helpers/Api';
import Validator from './Validator';
import Screen from '../../Shared/Helpers/Screen';
import BusyIndicator from '../../Shared/Helpers/BusyIndicator/BusyIndicator';

import { STEPS } from './constants';

export default class ContactScheduler extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentStep: STEPS.PERSONAL_DETAILS,
            appointment: {
                date: moment(),
                campaignId: props.campaignId
            },
            personalErrors: {},
            isBusy: true,
            data: {
                title: null,
                address: null,
                sheduleTimes: [],
                contactThankMessage: null
            }
        };

        this.moveNext = this.moveNext.bind(this);
        this.setAppointmentState = this.setAppointmentState.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.moveToStep = this.moveToStep.bind(this);
    }

    componentDidMount() {
        Api.getContactData().then((res) => {
            this.setState({
                data: res,
                isBusy: false
            });
        });
    }

    render() {
        let contactFormTitle = document.getElementById('appointment-wrap').getAttribute("data-title");
        let viewData = this.state.data;

        let view = null;

        if (this.state.isBusy) {
            view = <BusyIndicator />;
        } else {
            if (this.isFormActive) {

                view = (<ContactForm
                    data={this.state.data}
                    scheduleDate={this.state.appointment.date}
                    setAppointmentState={this.setAppointmentState}
                    moveNext={this.moveNext}
                    personalErrors={this.state.personalErrors}
                    currentStep={this.state.currentStep}
                    appointment={this.state.appointment}
                    appointmentDetails={this.props.center.appointmentDetails}
                />);
            } else {
                if (this.state.currentStep === STEPS.THANK_YOU) {

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'appointmentSuccessful',
                    });
                    view = <ThankYouScreen center={this.props.center} thankMessage={this.state.data.contactThankMessage} />;
                }
                if (this.state.currentStep === STEPS.ERROR) {
                    view = <ErrorScreen />;
                }
            }
        }

        return (
            <div className="appointment-scheduler">
                <div className="b-content">
                    <h1 className="b-header">
                        {contactFormTitle}
                    </h1>

                    {view}
                </div>
            </div>
        );
    }

    get isFormActive() {
        return this.state.currentStep === STEPS.PERSONAL_DETAILS;
    }

    setAppointmentState(e) {
        var field = e.target.name;
        var value = e.target.value;
        this.state.appointment[field] = value;

        // for now reseting errors for both steps for current name
        // as a quick solution

        delete this.state.personalErrors[field];

        return this.setState({
            appointment: this.state.appointment,
            personalErrors: this.state.personalErrors
        });
    }

    moveNext() {

        if (this.state.currentStep === STEPS.PERSONAL_DETAILS) {
            this.submitRequest();
        }
    }

    moveToStep(stepId) {
        this.setState({
            currentStep: stepId
        });
    }

    isPersonalValid() {
        let isValid = false;
        this.state.personalErrors = {};
        let appointment = this.state.appointment;

        if (!Validator.name(appointment.name)) {
            this.state.personalErrors['name'] = 'Please enter a valid name!';
        }

        if (!Validator.email(appointment.email)) {
            this.state.personalErrors['email'] = 'Please enter a valid email!';
        }

        if (!Validator.phone(appointment.phone)) {
            this.state.personalErrors['phone'] = 'Please enter a valid phone number!';
        }

        if (!Validator.comments(appointment.comment)) {
            this.state.personalErrors['comment'] = 'Comment exceeded max length';
        }
        if (!(appointment.captcha && appointment.captcha.getValue())) {
            this.state.personalErrors['captcha'] = 'Please check the captcha';
        }

        this.setState({
            personalErrors: this.state.personalErrors
        });

        if (!Object.keys(this.state.personalErrors).length) isValid = true;

        return isValid;
    }

    submitRequest() {
        if (this.isPersonalValid()) {
            this.setState({
                isBusy: true
            });
            
            this.state.appointment.captcha = undefined;
         
            let response = Api.submitContact(this.state.appointment)
                .then((res) => {
                    let nextStep = res.ok ? STEPS.THANK_YOU : STEPS.ERROR;

                    this.setState({
                        currentStep: nextStep,
                        isBusy: false
                    });
                });
        }
    }
}

function ThankYouScreen(props) {
    return (<div className="thank-you-wrapper centered-section">
        <img className="main-icon" src="/images/appointment/icon-success.svg" />
        <h3 className="step-title">
            Thank you
        </h3>
        <h4 className="subtitle">
            Your request has been sent successfully.
        </h4>


        {
            props.thankMessage !== null &&
            <small className="disclaimer" dangerouslySetInnerHTML={{ __html: props.thankMessage }} />
        }
        {
            props.thankMessage == null &&
            <small className="disclaimer">


                Please allow up to 24hr to receive your confirmation*.
        <br />
                If this is an emergency please contact our center by phone {" "}
                <a href={`tel:${props.center.phoneNumber}`}>
                    {props.center.phoneNumber}
                </a>

            </small>
        }
        <HomeBtn />
    </div>);
}

function ErrorScreen(props) {
    return (<div className="error-wrapper centered-section">
        <h3 className="step-title error">
            Error
            </h3>
        Please contact support
            <HomeBtn />
    </div>);
}

function HomeBtn(props) {
    return (
        <a className="apply-btn"
            href="/" >
            Back to Home
        </a>);
}

export let SchedulerInstance = null;

// used for direct component access from outside
let refCallback = (ref) => {
    SchedulerInstance = ref;
}

ReactDOM.render(<ContactScheduler ref={refCallback} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")} />, document.getElementById('appointment-wrap'));




// WEBPACK FOOTER //
// ./Src/Contact/ContactScheduler/ContactScheduler.jsx